import { Route, Navigate } from "react-router-dom";

import AdminLogin from "../pages/Admin/AdminLogin";
import AdminDashboard from "../pages/Admin/Dashboard";
import AdminDemoRequests from "../pages/Admin/AdminDemoRequests";
import AdminOrganizations from "../pages/Admin/AdminOrganizations";
import AdminVendors from "../pages/Admin/AdminVendors";
import AdminPlans from "../pages/Admin/AdminPlans";
import AdminUsers from "../pages/Admin/AdminUsers";
import AdminAnalytics from "../pages/Admin/AdminAnalytics";
import AdminSettings from "../pages/Admin/AdminSettings";
import AdminChat from "../pages/Admin/AdminChat";
import AdminLayout from "../components/Admin/AdminLayout";
import AddUser from "../components/UserOnboard";
import AdminPrivateRoute from "../components/AdminPrivateRoute";

export default function AdminRoutes() {
  return (
    <>
      <Route path="/admin/login" element={<AdminLogin />} />

      <Route
        path="/admin"
        element={
          <AdminPrivateRoute>
            <AdminLayout />
          </AdminPrivateRoute>
        }
      >
        <Route index element={<Navigate to="/admin/dashboard" replace />} />
        <Route path="dashboard" element={<AdminDashboard />} />
        <Route path="demo-requests" element={<AdminDemoRequests />} />
        <Route path="organizations" element={<AdminOrganizations />} />
        <Route path="vendors" element={<AdminVendors />} />
        <Route path="plans" element={<AdminPlans />} />
        <Route path="users" element={<AdminUsers />} />
        <Route path="analytics" element={<AdminAnalytics />} />
        <Route path="settings" element={<AdminSettings />} />
        <Route path="chat" element={<AdminChat />} />
        <Route path="profile" element={<div style={{ padding: "20px" }}>Profile Page - Coming Soon</div>} />
        <Route path="add-user" element={<AddUser />} />
      </Route>

      {/* Add all admin routes here */}
    </>
  );
}